var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("plotly", {
        ref: "map",
        attrs: {
          data: _vm.plotData,
          layout: _vm.plotLayout,
          "display-mode-bar": false,
        },
        on: { relayout: _vm.onZoom, autosize: _vm.onAutosize },
      }),
      _c("div", { ref: "test" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }